var map = {
	"./audio_icon.png": "d2d1",
	"./book_icon.png": "2f4d",
	"./bookmarks_icon.png": "bfd2",
	"./image_icon.png": "b483",
	"./link_icon.png": "eb92",
	"./notes_icon.png": "7205",
	"./pdf_icon.png": "2f9a6",
	"./video_icon.png": "fd65"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5e15";